import React from "react";

import { GridApi, ICellRendererParams, RowNode } from "@ag-grid-community/core";
import cn from "classnames";
import { useIntl } from "react-intl";

import FrequencyStatus from "@mapmycustomers/shared/enum/frequency/FrequencyStatus";
import Cadenced from "@mapmycustomers/shared/types/base/Cadenced";
import { isNotEmpty } from "@mapmycustomers/shared/util/assert";

import FrequencyIcon from "@app/component/frequency/FrequencyIcon";
import { messages } from "@app/util/fieldModel/impl/FrequencyStatusField";

import styles from "./FrequencyCellRenderer.module.scss";

const FrequencyCellRenderer: React.FC<ICellRendererParams> = ({
  node,
  value,
}: {
  api: GridApi;
  node: RowNode;
  value: Cadenced["cadenceDaysOut"];
}) => {
  const intl = useIntl();

  if (!isNotEmpty(value) || !intl) {
    // Wrapping into fragment because this component can't return a plain string.
    // On the other hand it can't return `null` because that's an AgGrid recommendation
    // to return empty strings: https://www.ag-grid.com/react-hooks/#react-null
    return <>{""}</>;
  }

  const status = node.data.cadenceStatus;

  return (
    <div className={styles.container}>
      <FrequencyIcon size="big" status={status} />
      <span
        className={cn(styles.message, {
          [styles.overdueMessage]: status === FrequencyStatus.PAST_DUE,
        })}
      >
        {status === FrequencyStatus.UP_TO_DATE
          ? intl.formatMessage(messages.upToDate, { count: -value })
          : value === 0
          ? intl.formatMessage(messages.overdueToday)
          : status === FrequencyStatus.PAST_DUE
          ? intl.formatMessage(messages.overdue, { days: value })
          : intl.formatMessage(messages.outSoon, { days: -value })}
      </span>
    </div>
  );
};

export default FrequencyCellRenderer;
